import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/creators/{creatorSlug}';

export type CreatorApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

export const useCreator = (
  params: CreatorApi['params'] | null,
  config?: UseNoodleSwrConfig<CreatorApi['response']>,
): SWRResponse<CreatorApi['response'], ApiError> => {
  const path = params ? buildPath<CreatorApi>(PATH_TEMPLATE, params) : null;
  return useNoodleSwr(path, { revalidateOnFocus: false, ...config });
};

/**
 * @deprecated: Please use `useCreator` wherever a perfectly fresh response is not worth the network time, bandwidth, and compute.
 */
const getCreator = async ({ creatorSlug }: CreatorApi['params']): Promise<CreatorApi['response']> => {
  const path = buildPath<CreatorApi>(PATH_TEMPLATE, { creatorSlug });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getCreator;
